import { useTranslation } from 'react-i18next'
import { BonusStatusEnum } from '@/enums'
import keys from '@/utils/keys'

import { WalletFilters } from '@/state/wallets/models'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'

type Props = {
  filters: WalletFilters
  handleChangeSearch: (
    newFilter: Partial<WalletFilters>,
    debounce?: boolean,
  ) => void
}

export const WalletStatusBonusFilter = ({
  filters,
  handleChangeSearch,
}: Props) => {
  const { t } = useTranslation()

  const bonusStatusOptions = [
    ...keys(BonusStatusEnum).map((index) => {
      return { key: index, value: BonusStatusEnum[index] }
    }),
  ]

  const statusValue = filters?.status
    ? filters.status.map((item) => {
        return {
          key: Object.keys(BonusStatusEnum)[
            Object.values(BonusStatusEnum).indexOf(item as BonusStatusEnum)
          ],
          value: item,
        }
      })
    : []

  return (
    <AutocompleteCustom
      id="status"
      name="status"
      options={bonusStatusOptions}
      getOptionLabel={(option: any) =>
        t(`wallet.walletStatusType.${option.key.toUpperCase()}`)
      }
      limitTags={1}
      multiple
      onChange={(_, newValue: any | null) => {
        handleChangeSearch(
          { status: newValue.map((value) => value.value) },
          true,
        )
      }}
      value={statusValue || []}
      label={t('statusBonus')}
      sx={{ '& .MuiFormControl-root': { marginBottom: '4px' } }}
    />
  )
}
